module.exports = __webpack_public_path__ + "img/haru.9e1caf68.png";